/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { IrrComponentsData } from '../model/irrComponentsData';
// @ts-ignore
import { IrrComponentsRawData } from '../model/irrComponentsRawData';
// @ts-ignore
import { PushIrrComponentsResponse } from '../model/pushIrrComponentsResponse';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class IrrProxyOperatorService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Extracts, transforms, and loads the inventory, health, and stats from IRR to provider agent apis
     * Extracts, transforms, and loads the inventory, health, and stats from IRR to provider agent apis
     * @param serviceType Service Type
     * @param irrFqdn FQDN of IRR
     * @param deploymentId Deployment identifier
     * @param getInventoryInfo Flag to indicate if Inventory info is required (default to true)
     * @param getHealthInfo Flag to indicate if health info is required (default to true)
     * @param getUsageInfo Flag to indicate if usage info is required (default to true)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public etlComponentDataOperator(serviceType: 'VCDR' | 'VMCFS' | 'VMUA', irrFqdn?: string, deploymentId?: string, getInventoryInfo?: boolean, getHealthInfo?: boolean, getUsageInfo?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<PushIrrComponentsResponse>;
    public etlComponentDataOperator(serviceType: 'VCDR' | 'VMCFS' | 'VMUA', irrFqdn?: string, deploymentId?: string, getInventoryInfo?: boolean, getHealthInfo?: boolean, getUsageInfo?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PushIrrComponentsResponse>>;
    public etlComponentDataOperator(serviceType: 'VCDR' | 'VMCFS' | 'VMUA', irrFqdn?: string, deploymentId?: string, getInventoryInfo?: boolean, getHealthInfo?: boolean, getUsageInfo?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PushIrrComponentsResponse>>;
    public etlComponentDataOperator(serviceType: 'VCDR' | 'VMCFS' | 'VMUA', irrFqdn?: string, deploymentId?: string, getInventoryInfo?: boolean, getHealthInfo?: boolean, getUsageInfo?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (serviceType === null || serviceType === undefined) {
            throw new Error('Required parameter serviceType was null or undefined when calling etlComponentDataOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serviceType, 'service-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>irrFqdn, 'irr-fqdn');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>deploymentId, 'deployment-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>getInventoryInfo, 'get-inventory-info');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>getHealthInfo, 'get-health-info');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>getUsageInfo, 'get-usage-info');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/irr-proxy/ETLComponentData`;
        return this.httpClient.request<PushIrrComponentsResponse>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get the components and their health and usage
     * Get the components and their health and usage in a deployment via an IRRs proxy API
     * @param serviceType Service Type
     * @param irrFqdn FQDN of IRR
     * @param deploymentId Deployment identifier
     * @param getInventoryInfo Flag to indicate if Inventory info is required (default to true)
     * @param getHealthInfo Flag to indicate if health info is required (default to true)
     * @param getUsageInfo Flag to indicate if usage info is required (default to true)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getIrrComponentsDataOperator(serviceType: 'VCDR' | 'VMCFS' | 'VMUA', irrFqdn?: string, deploymentId?: string, getInventoryInfo?: boolean, getHealthInfo?: boolean, getUsageInfo?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<IrrComponentsData>;
    public getIrrComponentsDataOperator(serviceType: 'VCDR' | 'VMCFS' | 'VMUA', irrFqdn?: string, deploymentId?: string, getInventoryInfo?: boolean, getHealthInfo?: boolean, getUsageInfo?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<IrrComponentsData>>;
    public getIrrComponentsDataOperator(serviceType: 'VCDR' | 'VMCFS' | 'VMUA', irrFqdn?: string, deploymentId?: string, getInventoryInfo?: boolean, getHealthInfo?: boolean, getUsageInfo?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<IrrComponentsData>>;
    public getIrrComponentsDataOperator(serviceType: 'VCDR' | 'VMCFS' | 'VMUA', irrFqdn?: string, deploymentId?: string, getInventoryInfo?: boolean, getHealthInfo?: boolean, getUsageInfo?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (serviceType === null || serviceType === undefined) {
            throw new Error('Required parameter serviceType was null or undefined when calling getIrrComponentsDataOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serviceType, 'service-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>irrFqdn, 'irr-fqdn');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>deploymentId, 'deployment-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>getInventoryInfo, 'get-inventory-info');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>getHealthInfo, 'get-health-info');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>getUsageInfo, 'get-usage-info');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/irr-proxy/getIrrComponentsData`;
        return this.httpClient.request<IrrComponentsData>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get the Inventory, Health and Status for the components
     * Get the Inventory, Health and Status for the components in an IRR
     * @param serviceType Service Type
     * @param irrFqdn FQDN of IRR
     * @param deploymentId Deployment identifier
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getIrrComponentsRawDataOperator(serviceType: 'VCDR' | 'VMCFS' | 'VMUA', irrFqdn?: string, deploymentId?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<IrrComponentsRawData>;
    public getIrrComponentsRawDataOperator(serviceType: 'VCDR' | 'VMCFS' | 'VMUA', irrFqdn?: string, deploymentId?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<IrrComponentsRawData>>;
    public getIrrComponentsRawDataOperator(serviceType: 'VCDR' | 'VMCFS' | 'VMUA', irrFqdn?: string, deploymentId?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<IrrComponentsRawData>>;
    public getIrrComponentsRawDataOperator(serviceType: 'VCDR' | 'VMCFS' | 'VMUA', irrFqdn?: string, deploymentId?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (serviceType === null || serviceType === undefined) {
            throw new Error('Required parameter serviceType was null or undefined when calling getIrrComponentsRawDataOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serviceType, 'service-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>irrFqdn, 'irr-fqdn');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>deploymentId, 'deployment-id');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/irr-proxy/getIrrComponentsRawData`;
        return this.httpClient.request<IrrComponentsRawData>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Push the inventory, health, and stats to their respective provider agent apis
     * Push the inventory, health, and stats to their respective provider agent apis
     * @param deploymentId Deployment identifier
     * @param irrComponentsData The irr components data to push to their respective provider agent apis
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pushIrrComponentsDataOperator(deploymentId: string, irrComponentsData: IrrComponentsData, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<PushIrrComponentsResponse>;
    public pushIrrComponentsDataOperator(deploymentId: string, irrComponentsData: IrrComponentsData, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PushIrrComponentsResponse>>;
    public pushIrrComponentsDataOperator(deploymentId: string, irrComponentsData: IrrComponentsData, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PushIrrComponentsResponse>>;
    public pushIrrComponentsDataOperator(deploymentId: string, irrComponentsData: IrrComponentsData, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (deploymentId === null || deploymentId === undefined) {
            throw new Error('Required parameter deploymentId was null or undefined when calling pushIrrComponentsDataOperator.');
        }
        if (irrComponentsData === null || irrComponentsData === undefined) {
            throw new Error('Required parameter irrComponentsData was null or undefined when calling pushIrrComponentsDataOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>deploymentId, 'deployment-id');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/irr-proxy/pushIrrComponentsData`;
        return this.httpClient.request<PushIrrComponentsResponse>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: irrComponentsData,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
